import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toPlainObject } from 'lodash';

import { PATH } from '../../constants/path';
import { STATIC_ROOT } from '../../constants';

import headerService from '../../services/header';

import Logo from '../icons/Logo';
import LocalizedNavLink from '../router/LocalizedNavLink';

import './HeaderComponent.scss';

class HeaderComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            stateOpenMenuMobileSlide: false
        };
    }

    onClickBtMenuMobile(e) {
        e.preventDefault();
        this.props.dispatch(
            headerService.actions.toggleMenuMobileSlide(
                headerService.constants.MENU_VERSION_MENU_MOBILE_SLIDE
            )
        );
    }

    render() {
        const { i18n, stateOpenMenuMobileSlide, hideNav, hideSearch, BRAND_NAME } = this.props;

        return (
            <header
                className={`tetedepage conteneur flex-container-h flex-center-alt ${
                    hideSearch ? 'hideSearch' : ''
                }`}>
                <LocalizedNavLink to={PATH.HOME_PATH} title={BRAND_NAME} className="logo">
                    <Logo />
                </LocalizedNavLink>

                <div className="poweredby">
                    <span>{i18n.POWERED_BY}</span>
                    <img
                        src={`${STATIC_ROOT}/logo-plebicom.png`}
                        alt="Plebicom"
                        width="79"
                        height="16"
                    />
                </div>

                {!hideNav && (
                    <button
                        className={`menu-mobile-bt menu-mobile-bt-listener show-mobonly ${
                            stateOpenMenuMobileSlide ? 'open' : ''
                        }`}
                        id="menu-mobile-bt"
                        data-target="menu"
                        onClick={this.onClickBtMenuMobile.bind(this)}>
                        <span />
                    </button>
                )}
            </header>
        );
    }
}

HeaderComponent.propTypes = {
    stateOpenMenuMobileSlide: PropTypes.bool.isRequired,
    versionOpenMenuMobileSlide: PropTypes.string.isRequired,
    hideNav: PropTypes.bool,
    hideSearch: PropTypes.bool
};

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    return {
        i18n: state.i18n.feature.header,
        isAuthenticated: state.authentication.isAuthenticated,
        fetching: state.authentication.fetching,
        user: toPlainObject(state.account.user),
        location: state.routing.location,
        stateOpenMenuMobileSlide: state.header.stateOpenMenuMobileSlide,
        versionOpenMenuMobileSlide: state.header.versionOpenMenuMobileSlide,
        BRAND_NAME: state.i18n.common.BRAND_NAME
    };
}

export default connect(mapStateToProps)(HeaderComponent);



// WEBPACK FOOTER //
// ./src/components/header/HeaderComponent.js